import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { SearchRequest } from './interfaces/search-request';
import { SearchResult } from './interfaces/search-result';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url = environment.apiUrl;

  users : any = [];
  private staffLookupSubject = new BehaviorSubject(this.users);
  public staffLookup = this.staffLookupSubject.asObservable();


  constructor(private http: HttpClient, public router: Router) {
    this.getStaffLookup();
  }

  resetPassword(resetPasswordDetails: any) {
    return this.http.post<any>(this.url + 'users/resetpassword', resetPasswordDetails, httpOptions);
  }
  createNewPassword(newPasswordDetails: any) {
    return this.http.post<any>(this.url + 'users/newpassword', newPasswordDetails, httpOptions);
  }

  paralegals() {
    return this.http.get<any>(`${this.url}users/paralegals`);
  }

  admins() {
    return this.http.get<any>(`${this.url}users/admins`);
  }

  companyGroups() {
    return this.http.get<any>(this.url + 'companygroups');
  }

  companyGroupsDetails(id: number) {
    return this.http.get<any>(this.url + 'companygroups/' + id);
  }

  addCompanyGroup(companyGroupDetails: any) {
    return this.http.put<any>(this.url + 'companygroups', companyGroupDetails, httpOptions);
  }

  updateCompanyGroup(companyGroupDetails: any) {
    return this.http.post<any>(this.url + 'companygroups', companyGroupDetails, httpOptions);
  }

  internalUsers(request: SearchRequest) {

    if (request.filterStrings.join() == '') {
      return this.http.get<SearchResult>(`${this.url}users/staff?page=${request.page}&pageSize=${request.pageSize}&orderBy=
        ${request.orderBy}&orderDirection=${request.orderDirection}`);
    }

    var queryString = '';

    for (var i = 0; i < request.filterStrings.length; i++) {
      if (request.filterStrings[i] !== '' && request.filterStrings[i] !== null) {
        queryString += `&filterColumns=${request.filterColumns[i]}&filterStrings=${request.filterStrings[i]}`
      }
    }

    return this.http.get<SearchResult>(`${this.url}users/staff?page=${request.page}&pageSize=${request.pageSize}&orderBy=
      ${request.orderBy}&orderDirection=${request.orderDirection}${queryString}`);

  }

  externalUsers(request: SearchRequest) {

    if (request.filterStrings.join() == '') {
      return this.http.get<SearchResult>(`${this.url}users/clients?page=${request.page}&pageSize=${request.pageSize}&orderBy=
        ${request.orderBy}&orderDirection=${request.orderDirection}`);
    }

    var queryString = '';

    for (var i = 0; i < request.filterStrings.length; i++) {
      if (request.filterStrings[i] !== '' && request.filterStrings[i] !== null) {
        queryString += `&filterColumns=${request.filterColumns[i]}&filterStrings=${request.filterStrings[i]}`
      }
    }

    return this.http.get<SearchResult>(`${this.url}users/clients?page=${request.page}&pageSize=${request.pageSize}&orderBy=
      ${request.orderBy}&orderDirection=${request.orderDirection}${queryString}`);

  }

  internalRoles() {
    return this.http.get<any>(this.url + 'auth/internalroles');
  }

  externalRoles() {
    return this.http.get<any>(this.url + 'auth/externalroles');
  }

  userDetails(id: number) {
    return this.http.get<any>(this.url + 'users/' + id);
  }

  basicUserDetails(id: number) {
    return this.http.get<any>(this.url + 'users/' + id + '/basic');
  }

  addUser(userDetails: any) {
    return this.http.put<any>(this.url + 'users', userDetails, httpOptions);
  }

  updateUser(id: number | undefined, userDetails: any) {
    return this.http.post<any>(this.url + 'users/' + id, userDetails, httpOptions);
  }

  teamLeaders() {
    return this.http.get<any>(`${this.url}users/teamleaders`);
  }

  adminsAndParalegals() {
    return this.http.get<any>(`${this.url}users/adminsandparalegals`);
  }

  private getStaffLookup() {

    this.http.get<SearchResult>(`${this.url}users/staff?page=1&pageSize=10000&orderBy=LastName&orderDirection=asc`).subscribe(results => {

      let users = [];
      for (const user of results.items) {
        users.push({ name: user.firstName + ' ' + user.lastName, id: user.id })
      }

      this.staffLookupSubject.next(users);
    });
  }

  companyGroupUsers(id: number) {
    return this.http.get<any>(this.url + 'users/companygroup/' + id);
  }

  authorisedSignatories() {
    return this.http.get<any>(`${this.url}users/authorisedsignatories`);
  }

  currentUserEmail() {
    return this.http.get<any>(this.url + 'users/currentuseremail');
  }

}
